export const seoKeywords = {
  name: 'keywords',
  content:
    'smart contract development, smart contracts development, blockchain development, ERC20 development, token development, Ethereum development, XRPL development, Solidity development, Rust development',
};

export const smartContractDevelopmentSeo = {
  title: 'Smart Contract Development Services with Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Smart contract development with Rumble Fish. From automated payment systems to complex DeFi protocols, we develop smart contracts that handle real-world complexity with enterprise-grade reliability.',
    },
  ],
};
